var _rect, _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUserSales(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 16,
    fill: "#F8F5FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_32785_14355)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.5 27.25C29.5384 27.25 30.5534 26.9421 31.4167 26.3653C32.2801 25.7884 32.953 24.9684 33.3503 24.0091C33.7477 23.0498 33.8517 21.9943 33.6491 20.9759C33.4465 19.9575 32.9465 19.0219 32.2123 18.2876C31.4781 17.5534 30.5426 17.0534 29.5242 16.8509C28.5058 16.6483 27.4502 16.7523 26.4909 17.1497C25.5316 17.547 24.7116 18.2199 24.1348 19.0833C23.5579 19.9466 23.25 20.9617 23.25 22C23.2503 23.3923 23.8035 24.7274 24.788 25.7119C25.7725 26.6965 27.1077 27.2498 28.5 27.25Z",
    stroke: "#8C52FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.75 39.25C18.75 36.6641 19.7772 34.1842 21.6057 32.3557C23.4342 30.5272 25.9141 29.5 28.5 29.5C31.0859 29.5 33.5658 30.5272 35.3943 32.3557C37.2228 34.1842 38.25 36.6641 38.25 39.25",
    stroke: "#8C52FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_32785_14355"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 24,
    fill: "white",
    transform: "translate(18 16)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserSales);
export default __webpack_public_path__ + "static/media/user-sales.1e68c3ab1e4f4a84a8a18f08d96f6550.svg";
export { ForwardRef as ReactComponent };